


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { CenposAccountAddOrUpdateViewModel } from '@/models/payment/cenposAccount';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class AddCenposAccountPage extends Base {
  public vm: CenposAccountAddOrUpdateViewModel = new CenposAccountAddOrUpdateViewModel();
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public disableSubmitButton: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.vm.storeId.toString(), tab: 'CenposAccount' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('cenposAccounts.alertFormInvalid'));
        this.resetMethodName(methodName);
        return;
      }
      this.submitCenposAccount();
    } else {
      console.log(methodName);
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('stores.btnBackToStoreTitle'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('stores.btnBack'),
      click: 'backToStoreEdit',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setFields();
    this.vm.storeId = Number(this.$route.params.storeId);
    this.getCenposAccountDetails();
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'merchantId',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t(
            'cenposAccounts.cenposAccountFields.merchantId'
          ) as string,
          required: true,
          disabled: false,
          rules:[
            v => this.required('Merchant Id',v)
          ]
        },
      },
      {
        key: 'merchantIdEncoded',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t(
            'cenposAccounts.cenposAccountFields.merchantIdEncoded'
          ) as string,
          required: true,
          disabled: false,
          rules:[
            v => this.required('Merchant Id Encoded',v)
          ]
        },
      },
      {
        key: 'secretKey',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'cenposAccounts.cenposAccountFields.secretKey'
          ) as string,
          required: true,
          disabled: false,
          rules:[
            v => this.required('Secret Key',v)
          ]
        },
      },
      {
        key: 'paymentUrl',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'cenposAccounts.cenposAccountFields.paymentUrl'
          ) as string,
          required: true,
          disabled: false,
          rules:[
            v => this.required('Payment Url',v)
          ]
        },
      },
    ];
  }
  
  public validateCenposAccount(): Vue & { validate: () => boolean } {
    return this.$refs.cenposAccountForm as Vue & { validate: () => boolean };
  }

  public async submitCenposAccount(): Promise<void> {
    if(this.validateCenposAccount().validate()){
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        await storeService.updateCenposAccounts(
          this.vm.storeId,
          this.vm.account
        );
        this.showAlert(true, this.$t('cenposAccounts.alertSaveCenposAccount'));
        this.$router.push({
          name: 'admin.stores.edit',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            storeId: this.vm.storeId.toString(),
            tab: 'CenposAccount'
          },
        });
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public async getCenposAccountDetails(): Promise<void> {
    try {
      if (this.vm.id) {
        this.formlyShowSkeleton(this.formFields);
      }

      const response = await storeService.getCenposAccountDetails(
        this.vm.storeId
      );
      if (response) {
        this.vm.account = response;
      }
    } finally {
      if (this.vm.id) {
        this.formlyHideSkeleton(this.formFields);
      }
    }
  }
}
